import type { IconSvgObject } from './types';

const Wallet04Icon: IconSvgObject = [
  ["path", { d: "M3 8.5H19C20.1046 8.5 21 9.39543 21 10.5V19.5C21 20.6046 20.1046 21.5 19 21.5H5C3.89543 21.5 3 20.6046 3 19.5V8.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 8.49833V3.31823C15 2.86633 14.6337 2.5 14.1818 2.5C14.0621 2.5 13.9438 2.52627 13.8353 2.57697L3.77652 7.27825C3.30275 7.49968 3 7.97536 3 8.49833", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Wallet04Icon;
